import React, { Fragment, ReactNode, useEffect, useCallback } from 'react';
import { Prompt } from 'react-router';

interface IProps {
  enabled: boolean;
  children: ReactNode
}

const BeforeUnload = (props: IProps) => {
  const { enabled, children } = props;

  const onUnload = useCallback((event: BeforeUnloadEvent) => {
    if (!enabled) {
      return null;
    }

    event.preventDefault();
    event.returnValue = 'You have unsaved changes. Please save them before leaving this page.';
  }, [enabled])

  useEffect(() => {
    window.addEventListener('beforeunload', onUnload);

    return () => {
      window.removeEventListener('beforeunload', onUnload);
    }
  }, [onUnload, enabled])

  return (
    <Fragment>
      <Prompt
        when={enabled}
        message='You have unsaved changes, are you sure you want to leave?'
      />
      {
        children
      }
    </Fragment>
  )
}

export default BeforeUnload;
